import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormSlider from '../../../library/form/components/FormSlider'
import coreSetting from '../../../helper/coreSetting';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSH from '../../../library/form/components/FormSH';
import FormWrapper from '../../../library/form/components/FormWrapper';
import { UiGridColTwo,UiCol, UiRow } from "../../../library/layout/Index";

const ProHeader1Editor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    //TODO manish: check the example below for FormSH and use it in other components as applicable
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '700px', height: '650px' }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
            <UiGridColTwo>
                <UiCol>
                    <ul >
                        <li>
                            <span style={{width:"125px"}} className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isCompany" }} value="Is Company" />
                            </span>
                            <div style={{width:"auto", display: 'inline-block'}} className="uiRow uiSpacer" id="sendNotify" >
                                <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isCompany" }} />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "docID" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "company" }} value="Account Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" autofocus action={{ InputType: "input", paramName: "company" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "acCompany" }} value="Company" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                                action={{ InputType: "ac", paramName: "acCompany", acMethod: "CompanyName" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refChannel" }} value="Channel" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "refChannel", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "refChannel",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                ></FormSH>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory" }} value="Category 1" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="shCatPCLink" className="uiInput"
                                action={{ InputType: "ac", paramName: "profileCategory", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "profileCategory",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} value="Category 2" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="shCatPCLink" className="uiInput"
                                action={{ InputType: "ac", paramName: "profileCategory2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "profileCategory2",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "website" }} value="Website" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="websiteTxt" className="uiInput"
                                action={{ InputType: "input", paramName: "website" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "businessDetail" }} value="Business Details" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="businessDetailTxt" className="uiInput"
                                action={{ InputType: "input", paramName: "businessDetail" }} />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul >
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentProfile" }} value="Parent ID" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "parentProfile", acMethod: "ParentProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1  } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "relationWith" }} value="Account Owner" />
                            </span>
                            <FormInput formObject={formObject} rowKey=""  className="uiInput"
                                action={{ InputType: "ac", paramName: "relationWith", acMethod: "UserNames", }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "input", paramName: "nickName" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "relationSince" }} value="Account Since" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                action={{ InputType: "dp", paramName: "relationSince" }} />

                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refCode" }} value="Reference Code" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="refCodeTxt" className="uiInput"
                                action={{ InputType: "input", paramName: "refCode" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priority" }} value="Priority" />
                            </span>
                            <div className="uiInline">
                                <FormSlider formObject={formObject} rowKey="" action={{ paramName: "priority", datalist: coreSetting.priorityList.Priority }} />
                            </div>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }} value="Sort No" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="sortOrder" className="uiInput"
                                action={{ InputType: "input", paramName: "sortOrder" }} />
                        </li>
                        <li>
                            <span style={{width:"125px"}} className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notify" }} value="Send Notification" />
                            </span>
                            <div style={{width:"auto", display: 'inline-block'}} className="uiRow uiSpacer" id="sendNotify" >
                                <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "notify" }} />
                            </div>
                        </li>
                    </ul>
                </UiCol>
                </UiGridColTwo>
                <UiRow>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark" }} value="Comments 1" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                        action={{ paramName: "remark" }} />

                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark2" }} value="Comments 2" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                        action={{ paramName: "remark2" }} />
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark3" }} value="Comments 3" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                        action={{ paramName: "remark3" }} />
                </UiRow>
        </FormDialog>
    )
}

export default withView(ProHeader1Editor, "proHeader", "proHeader")